export default __webpack_public_path__ + "d1545d7d3e87e490f186977a32684a86.png";